function deliveyTimeChange(deliveryTime){
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        time: deliveryTime
      }
    })
  })
}

$(document).ready(function() {
  $(document).on("change", "#time_drawer", function() {
    deliveyTimeChange($(this).val())
    $("#time").val($(this).val())
  });
  $(document).on("change", "#time", function() {
    deliveyTimeChange($(this).val())
    $("#time_drawer").val($(this).val())
  });
});